import { type LoaderFunctionArgs, redirect } from "@remix-run/node";
import { Outlet, useLoaderData } from "@remix-run/react";
import { ROUTES } from "~/consts";
import { destroySession, getSession } from "~/session.server";

export interface OnboardV2LayoutContext {
	inIframe: boolean;
}

export async function loader({ request }: LoaderFunctionArgs) {
	const url = new URL(request.url);
	const inIframe = url.searchParams.get("iframe") === "1";

	const session = await getSession(request);

	// Force logout if user is already logged in
	if (session.has("accessToken")) {
		return redirect(ROUTES.company.onboardV2.stage1, {
			headers: {
				"Set-Cookie": await destroySession(session),
			},
		});
	}

	return { inIframe };
}

export default function OnboardV2Layout() {
	const loaderData = useLoaderData<typeof loader>();
	return (
		<div
			className={`${loaderData?.inIframe ? "rounded-3xl" : ""} bg-secondary`}
		>
			<Outlet context={{ inIframe: loaderData?.inIframe }} />
		</div>
	);
}
